import { of, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {

  private ENDPOINT_REGSITER_ORG = "/register";
  private ENDPOINT_FORGOT_PASSWORD = "/users/reset-password/init";
  private ENDPOINT_RESET_PASSWORD = "/users/reset-password/finish";
  private ENDPOINT_RESEND_EMAIL = "/resend-activation-email/";
  private ENDPOINT_RESEND_CUSTOMER_USER_EMAIL = "/resend-customer-user-activation-email/";

  constructor(private http: HttpClient) { }

  public registerOrg(body: any): Observable<any> {
    return this.http.post(environment.base_url + this.ENDPOINT_REGSITER_ORG, body).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        console.error('Register Org Error:', error);
        return of(error);
      })
    );
  }

  public resetPasswordForCustomer(body: any): Observable<any> {
    return this.http.post(environment.base_url + '/customer-users/reset-password/init', body,{ observe: 'response' }).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        console.error('Reset Password Customer Error:', error);
        return of(error);
      })
    );
  }

  public forgotPassword(body: any): Observable<any> {
    return this.http.post(environment.base_url + this.ENDPOINT_FORGOT_PASSWORD, body,{ observe: 'response' }).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        console.error('Forgot Password Error:', error);
        return of(error);
      })
    );
  }

  public resetPassword(body: any): Observable<any> {
    return this.http.post(environment.base_url + this.ENDPOINT_RESET_PASSWORD, body,{ observe: 'response' }).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        console.error('Reset Password Error:', error);
        return of(error);
      })
    );
  }

  public resendEmail(id: any): Observable<any> {
    return this.http.put(environment.base_url + this.ENDPOINT_RESEND_EMAIL + id, {}, { observe: 'response' }).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        console.error('Resend Email Error:', error);
        return of(error);
      })
    );
  }

  public resendCustomerUserEmail(id: any): Observable<any> {
    return this.http.put(environment.base_url + this.ENDPOINT_RESEND_CUSTOMER_USER_EMAIL + id, {}, { observe: 'response' }).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        console.error('Resend Customer User Email Error:', error);
        return of(error);
      })
    );
  }
}